export const COMPARE_ADD_ITEM = 'COMPARE_ADD_ITEM'
export const COMPARE_REMOVE_ITEM = 'COMPARE_REMOVE_ITEM'
export const COMPARE_CLEAR_ITEMS = 'COMPARE_CLEAR_ITEMS'
export const COMPARE_SHOW_BAR = 'COMPARE_SHOW_BAR'
export const COMPARE_HIDE_BAR = 'COMPARE_HIDE_BAR'

export const SET_COMPARE_ITEMS = 'SET_COMPARE_ITEMS'
export const SET_COMPARE_ERROR = 'SET_COMPARE_ERROR'
